// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "price-3tVCD";
export { _1 as "__esModule", _2 as "price" }
export default { "__esModule": _1, "price": _2 }
